import React, { useEffect } from 'react';

interface AdditionalsIconProps {
    fill?: string;
}

export const AdditionalsIcon = ({ fill = 'black' }: AdditionalsIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_6001_51748)">
                <path
                    d="M0.853333 5.37305L7.33333 7.98638V4.66572H8.852C9.08333 5.06239 9.50867 5.33239 10 5.33239H13.3333C14.0687 5.33239 14.6667 4.73439 14.6667 3.99905C14.6667 3.26372 14.0687 2.66572 13.3333 2.66572H10C9.50867 2.66572 9.08333 2.93572 8.852 3.33239H7.33333V0.0117188L0.853333 2.62505C0.326667 2.89172 0 3.41772 0 3.99905C0 4.58039 0.326667 5.10638 0.853333 5.37305ZM1.40333 3.83905L6 1.98705V6.01239L1.43733 4.17372C1.40559 4.15718 1.37906 4.13216 1.3607 4.10144C1.34234 4.07072 1.33286 4.03551 1.33333 3.99972C1.33333 3.94439 1.35467 3.86639 1.40333 3.83905ZM8.66667 6.66639V10.6664H0V15.9997H16V6.66639H8.66667ZM10.6667 11.9997V14.6664H5.33333V11.9997H10.6667ZM1.33333 11.9997H4V14.6664H1.33333V11.9997ZM14.6667 14.6664H12V11.9997H14.6667V14.6664ZM10 10.6664V7.99972H14.6667V10.6664H10Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_6001_51748">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
